import { render } from "./DynamicRouter.vue?vue&type=template&id=3be2f7ab"
import script from "./DynamicRouter.vue?vue&type=script&lang=js"
export * from "./DynamicRouter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Layout/DynamicRouter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3be2f7ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3be2f7ab', __exports__)) {
    console.log('reload')
    api.reload('3be2f7ab', __exports__)
  }
  
  module.hot.accept("./DynamicRouter.vue?vue&type=template&id=3be2f7ab", () => {
    console.log('re-render')
    api.rerender('3be2f7ab', render)
  })

}


export default __exports__